/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';
import {Button, Col, Panel, Row} from 'react-bootstrap';
import { connect } from 'react-redux';
import { Field, Form, propTypes, reduxForm } from 'redux-form';
import { remove as removeAction, save as saveAction } from '../../../../reducers/costCodeCategory/costCodeCategory.actions';
import { isLocal } from '../../../../reducers/localId/localId';
import SpinnerButton from '../../../SpinnerButton/SpinnerButton';
import TTFormGroup from '../../../Forms/TTFormGroup/TTFormGroup';
import UnsavedChangesPrompt from '../../../UnsavedChangesPrompt/UnsavedChangesPrompt';
import './CostCodeCategoryForm.css';

// eslint-disable-next-line object-curly-newline
export class CostCodeCategoryForm extends React.Component {
  constructor() {
    super();
    this.state = {
      showFields: false,
    };
  }

  render() {
    const {submitting, dirty, remove, save, initialize, handleSubmit, costCodeCategory: {name, removing, id}} = this.props;

    return (
      <span>
        {dirty && <UnsavedChangesPrompt dirty/>}
        <Row style={{'margin-top': "-14px"}}>
          <Col md={1}><Button style={{'height': "14px", "padding": "5px 15px 20px 15px", "font-size": "14px"}} onClick={() => this.setState({showFields: !this.state.showFields})}>Edit</Button></Col>
          <Col md={11} style={{'font-size': "14px"}}>{name}</Col>
        </Row>
    <Panel>

        {(this.state.showFields || id.toString().includes('LOCAL')) &&
          <Form
            onSubmit={
              handleSubmit(values =>
                save(values, id)
                  .then(costCodeCategory => initialize(costCodeCategory.response)))}
          >
            <Row>
              <Col md={4}>
                <Field
                  component={TTFormGroup}
                  name="name"
                  label="Name"
                  type="text"
                  required
                />
              </Col>
            </Row>
            <Row>
              <Col xs={6} md={2}>
                <SpinnerButton
                  isLoading={submitting}
                  type="submit"
                  dirty={dirty}
                >
                  {isLocal(id) ? 'Add' : 'Save'}
                </SpinnerButton>
              </Col>
              <Col xs={6} md={2}>
                <SpinnerButton
                  isLoading={removing}
                  onClick={() => remove(id)}
                  bsStyle="danger"
                >
                  Remove
                </SpinnerButton>
              </Col>
            </Row>
          </Form>
        }
    </Panel>
      </span>);
  }
}

CostCodeCategoryForm.propTypes = {
  ...propTypes,
  costCodeCategory: PropTypes.shape({
    isRemoving: PropTypes.bool.isRequired,
  }).isRequired,
};

export const mapStateToProps = (state, ownProps) => ({
  initialValues: ownProps.costCodeCategory,
  form: `CostCodeCategory${ownProps.costCodeCategory.id}`,
});

export const mapDispatchToProps = dispatch => ({
  remove: id => dispatch(removeAction(id)),
  save: (values, id) => dispatch(saveAction({ ...values, id })),
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({ enableReinitialize: true })(CostCodeCategoryForm));



// WEBPACK FOOTER //
// ./src/components/Admin/CostCodeCategories/CostCodeCategoryForm/CostCodeCategoryForm.jsx